import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert as MuiAlert
} from '@mui/material'
import { useState, forwardRef } from 'react'
import { useNavigate } from 'react-router-dom'
import BusinessDialog from './business/businessDialog'
import { useEffect } from 'react'
import { SnackBarHideDuration, SnackBarTransition } from '../../utils/ui_utils'
import { useBusinessCreate } from '../../modules/business/businessHooks'
import { useApplicationFetch } from '../../modules/application/applicationHooks'

function CreateBusiness() {
  const [snackbar, setSnackBar] = useState(false)
  const [PopUpMessage, setPopUpMessage] = useState(null)
  const [severity, setSeverity] = useState(null)
  const {
    businessCreateData,
    businessCreateError,
    businessCreateLoading,
    createBusiness
  } = useBusinessCreate()
  const { applicationFetch, loading, error, data } = useApplicationFetch()

  const handleSnackbarClose = () => {
    setSnackBar(false)
  }

  const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
  })

  const toastMessage = (message, severity) => {
    setPopUpMessage(message)
    setSeverity(severity)
    setSnackBar(true)
  }
  const [open, setOpen] = useState(true)
  const [confirmCancelPopup, setConfirmCancelPopup] = useState(false)

  const history = useNavigate()
  const initialValues = {
    name: '',
    gstn: '',
    telephone: '',
    fax: '',
    cin: '',
    address: '',
    city: '',
    pin: '',
    state: '',
    country: '',
    application_id: '',
    multi_outlet: false,
    dealer_code: ''
  }

  useEffect(() => {
    let payload = {
      pageNumber: 1,
      limit: 100
    }
    applicationFetch(payload)
  }, [])

  const handleConfirmOpen = () => {
    setConfirmCancelPopup(true)
  }

  const handleConfirmClose = () => {
    setConfirmCancelPopup(false)
  }

  const onConfirmCloseBusinessPopup = () => {
    localStorage.clear()
    history('/auth/sign-in')
  }

  return (
    <div>
      <BusinessDialog
        visible={open}
        title="Create New Business"
        okText="Create"
        onSubmit={async (value) => {
          let values = _.cloneDeep(value)
          if (!values.gstn) {
            delete values.gstn
          }
          if (!values.telephone) {
            delete values.telephone
          }
          if (!values.fax) {
            delete values.fax
          }
          if (!values.cin) {
            delete values.cin
          }
          if (!values.city) {
            delete values.city
          }
          if (!values.address) {
            delete values.address
          }
          if (!values.pin) {
            delete values.pin
          }
          if (!values.state) {
            delete values.state
          }
          if (!values.country) {
            delete values.country
          }
          if (!values.dealer_code) {
            delete values.dealer_code
          }
          console.log('values', values)

          try {
            await createBusiness(values, (success, error, message) => {
              if (error) {
                console.log('error', message)
                toastMessage(message, 'error')
              } else {
                toastMessage('Business created', 'success')
                localStorage.clear()
                history('/auth/sign-in')
              }
            })
          } catch (error) {
            toastMessage('Business not created', 'error')
          }
        }}
        onClose={() => {
          handleConfirmOpen()
        }}
        initialValues={initialValues}
        applicationData={data}
      />

      <Dialog
        open={confirmCancelPopup}
        onClose={handleConfirmClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Confirmation</DialogTitle>
        <DialogContent>Don't want to create Business?</DialogContent>
        <DialogActions>
          <Button onClick={handleConfirmClose} variant="outlined" size="small">
            Cancel
          </Button>
          <Button
            onClick={() => onConfirmCloseBusinessPopup()}
            color="primary"
            autoFocus
            variant="outlined"
            size="small"
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <div>
        <Snackbar
          open={snackbar}
          autoHideDuration={SnackBarHideDuration}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          onClose={handleSnackbarClose}
          TransitionComponent={SnackBarTransition}
        >
          <Alert onClose={handleSnackbarClose} severity={severity}>
            {PopUpMessage}
          </Alert>
        </Snackbar>
      </div>
    </div>
  )
}

export default CreateBusiness
